module.exports = __webpack_public_path__ + "img/icon-arrow--prev.5e5c483b.svg";